<article>
  <h1>《goingbus隐私协议》</h1>
  <p>
    本政策适用于goingbus提供的所有产品和服务，包括goingbus官网及微信平台。请您在使用我们的官网、微平台及产品或服务前，仔细阅读并了解本《隐私政策》。
  </p>
  <h2>一、我们如何收集和使用您的个人信息</h2>
  <p>
    您在使用goingbus官网（以下简称“本网站”）各项业务的过程中，我们需要收集您的一些信息，帮助您成为我们的用户，向您提供良好的服务，为您优化用户体验，并提供安全保障。
  </p>
  <h3>1、创建账号信息</h3>
  <p>
    当您注册本网站个人用户账号时，您需要提供您的手机号码、微信订阅信息。收集这些信息是为了帮您创建账号，如果您拒绝提供这些信息，将影响您的注册使用。
  </p>
  <h3>2、在线支付</h3>
  <p>
    当您在本网站购买服务时，您可以选择与我们合作的第三方支付机构所提供的支付服务。支付服务本身并不收集您的个人信息，但我们需要将您的订单号与交易金额信息与支付机构共享以实现其确认您的支付指令并完成支付。
  </p>

  <h2>二、我们如何保护您的个人信息</h2>
  <p>
    1、我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
  </p>

  <h2>三、您的权利</h2>
  <p>
    按照相关的法律、法规、标准、以及其他国家地区的通行做法，我们保障您对自己的个人信息行使以下权利：
  </p>
  <ul>
    <li>
      1、访问您的个人信息。您有权访问您的个人信息，法律法规规定的例外情况除外。
    </li>
    <li>
      2、更正您的个人信息。当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过邮箱提出更正申请。
    </li>
    <li>
      3、删除您的个人信息
      <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
      <ul>
        <li>①、如果我们处理个人信息的行为违反法律法规；</li>
        <li>②、如果我们收集、使用您的个人信息，却未征得您的同意；</li>
        <li>③、如果我们处理个人信息的行为违反了与您的约定；</li>
        <li>④、如果您不再使用我们的产品或服务，或您主动注销了账号；</li>
        <li>⑤、如果我们不再为您提供产品或服务。</li>
      </ul>
      <p>
        当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份系统更新时删除这些信息。
      </p>
    </li>
    <li>
      4、响应您的上述请求
      <p>
        为保障安全，您可以需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </p>
      <p>
        对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改编现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁盘上存放的信息）的请求，我们可能会予以拒绝。
      </p>
      <p>在以下情形中，我们将无法响应您的请求：</p>
      <ul>
        <li>①、与个人信息控制者履行法律法规规定的义务相关的；</li>
        <li>②、与国家安全、国防安全直接相关的；</li>
        <li>
          ③、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；
        </li>
        <li>④、涉及商业秘密的。</li>
      </ul>
    </li>
    <li>
      5、如何联系我们
      <p>联系我们：admin@goingbus.com</p>
      <ul>
        <li>
          ①、如您对本《goingbus隐私政策》或使用我们的服务相关的事宜有任何问题（包括问题咨询、投诉等），我们设立了专门的反馈通道，您可以通过admin@goingbus.com向我们反馈您的意见或建议。
        </li>
        <li>
          ②、我们会在收到您的意见及建议后，并在验证您后用户身份后的30日内尽快向您回复，一般情况下，我们不会因此对您收取服务费。但是，在以下情形下，您理解并知悉，我们将无法响应您的请求：
          与国家安全、国防安全有关的；
          与公共安全、公共卫生、重大公共利益有关的；
          与犯罪侦查、起诉和审判等有关的；
          有充分证据表明您存在主观恶意或滥用权利的；
          响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        </li>
        <li>
          ③、如果您对我们的回复不满意，或我们对您个人信息的处理方式侵害了您的合法权益，且在您向我们反馈后我们仍拒绝改进的，您可以向相关部门进行投诉、举报。
        </li>
      </ul>
    </li>
  </ul>
  <h2>四、其他</h2>
  <ul>
    <li>
      ①、本《goingbus隐私政策》相关的任何纠纷，双方应协商友好解决；若不能协商解决，您同意将争议提交至goingbus所在地人民法院提起诉讼。
    </li>
    <li>
      ②、本《goingbus隐私政策》的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
    </li>
  </ul>
</article>
